import React from 'react';
import './UserDashboard.css';
import Navigation from './Navigation/Navigation'
function UserDashboard() {
    return(
        <section>
       <Navigation />
       </section>
    )
}
export default UserDashboard;